import axios from 'axios';
import moment from 'moment';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    listBuktiPotong(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/documents/bukti-potong-pajak${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    uploadBuktiPotong(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                 const { data } = await axios.post('/documents/upload-bukti-potong-pajak', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    ekstrakBuktiPotong(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('/documents/ekstrak-bukti-potong', obj)
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}